<template>
<div>
      <v-card-title>
        <v-text-field
          name="name"
          label="Auftrag"
          id="id"
          v-model="search.query"
          autocomplete="off"
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-iterator
          :items="searchResults"
          row
          wrap
          hide-actions
        >
          <template v-slot:item="props">
            <v-flex xs12>
              <v-card class="mb-2" >
                <v-card-title primary-title class="pt-3 pb-0 clickable" @click="$router.push({ name: 'BillingListShow', params: { id: props.item.id }})">
                  <v-layout row>
                    <v-flex pa-1 grow>
                      <div class="subheading">
                        {{ props.item.display_name }}
                      </div>
                      <span class="grey--text">{{ props.item.customer }} ( {{ props.item.project }})</span>
                    </v-flex>
                  </v-layout>
                </v-card-title>
              </v-card>
            </v-flex>
          </template>
        </v-data-iterator>
      </v-card-text>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import { BILLINGLIST_INDEX } from '../../store/actions/billingList'
export default {
  data () {
    return {
      headers: [
        {
          text: 'Name',
          value: 'display_name'
        },
        {
          text: 'Kunde',
          value: 'customer'
        },
        {
          text: 'Projekt',
          value: 'project'
        }
      ],
      pagination: {
        sortBy: 'timestamp',
        descending: true,
        rowsPerPage: 25
      },
      search: {
        query: '',
        dialog: false,
        results: []
      }
    }
  },
  computed: {
    ...mapGetters([
      BILLINGLIST_INDEX
    ]),
    searchResults () {
      if (this.search.results.length) {
        return this.search.results
      } else {
        return this.BILLINGLIST_INDEX
      }
    }
  },
  mounted () {
    this.$store.dispatch(BILLINGLIST_INDEX)
  },
  methods: {
    editEntry (lineId) {
      /* this.$store.dispatch(TIMEENTRY_GET, lineId).then(resp => {
        this.$router.push({name: 'timeentry', params: { edit: resp }})
      }) */
    }
  },
  watch: {
    'search.query' (val) {
      this.$search(val, this.BILLINGLIST_INDEX, { keys: ['customer', 'display_name', 'project'] }).then(result => {
        this.search.results = result
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BillingList/Index.vue